export const ARTICLE_DETAIL_COMPANY_IMAGE_CLASS_NAME =
  "article-detail-company-image";
